<div class="
  relative select-none 
  md:w-[64px] md:h-[64px]
  w-[48px] h-[48px]"
  [class.cursor-pointer]="!disabled && !isProcessing"
  [class.cursor-not-allowed]="disabled || isProcessing"
  [appTooltip]="tooltipText | translate"
  appTooltipPosition="above"
  [appTooltipAlign]="tooltipAlignment"
  [appTooltipClass]="disabledTooltip ? 'whitespace-normal max-w-[min(340px,calc(100vw-4.5rem))]' : null">
  <!-- Outer spinner ring when loading -->
  <!-- <div *ngIf="state === RecordingState.Loading" class="absolute inset-0 flex items-center justify-center">
    <div class="absolute inset-0 rounded-full border-[3px] border-transparent border-t-white/70 animate-spin"></div>
  </div> -->

  <!-- Main circular button -->
  <button type="button"
          [disabled]="disabled || isProcessing"
          class="group absolute inset-[2px] rounded-full overflow-hidden shadow-lg ring-1 ring-black/10 flex items-center justify-center focus:outline-none {{ bgClass }}"
          [class.pointer-events-none]="disabled || isProcessing"
          (click)="onClick()">
    <!-- Brackets (below canvas) -->
    @if (mode === 'dictate') {
      <img src="assets/left-bracket.svg" alt="" 
        class="
          absolute opacity-60 z-10 invert
          md:h-5 md:left-3
          h-4 left-2" />
      <img src="assets/right-bracket.svg" alt="" 
        class="
          absolute opacity-60 z-10 invert
          md:right-3 md:h-5
          right-2 h-4" />
    }

    <!-- Center stage for icon/visualizer -->
    <div class="absolute inset-0 flex items-center justify-center pointer-events-none z-20">
      <canvas #miniCanvas width="64" height="24" [class.hidden]="state !== RecordingState.Recording"></canvas>
      @if (mode === 'dictate' && state !== RecordingState.Recording && !disabled) {
        <mat-icon svgIcon="microphone"      
          class="
            icon-size !text-white !leading-10
            md:[--icon-size:20px] 
            [--icon-size:16px]"></mat-icon>
      }
      @if (mode === 'dictate' && state !== RecordingState.Recording && disabled) {
        <mat-icon svgIcon="microphone-mute" 
          class="
            icon-size disabled-mic-icon
            md:[--icon-size:20px] 
            [--icon-size:16px]"></mat-icon>
      }
      @if (mode === 'smartDictation' && state !== RecordingState.Recording) {
        <img
          src="assets/smart-dictation.svg"
          alt=""
          class="absolute inset-0 h-full w-full rounded-full object-cover"
          [class.opacity-60]="disabled" />
      }
    </div>
    
    <!-- Loading spinner overlay -->
    <div *ngIf="isProcessing" class="absolute inset-0 flex flex-col items-center justify-center z-30 rounded-full {{ bgClass }}">
      <div class="
        spinner flex items-center justify-center rounded-full 
        md:w-9 md:h-9
        w-7 h-7">
        <div class="
          rounded-full {{ bgClass }} 
          md:w-7.5 md:h-7.5
          w-5.5 h-5.5"></div>
      </div>
    </div>
  </button>
</div>


